module.exports = __webpack_public_path__ + "static/Adobe_Desktop-05cc3bfe0656a9e6a77a883e44fdb6d4.jpg";